module.exports = __webpack_public_path__ + "static/img/award2_a.349e340.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/index/award2_a.png
// module id = Kegx
// module chunks = 7